export default {"src":"/_next/static/media/clock.924ef4ab.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};